import _ from 'lodash'
import giftRuleApi from '@/api/gift-rule'
import store from '@/store'
import form from './form'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    searchQuery: '',
    sortBy: '',
    sortDesc: false,
  },
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    giftRuleApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
  },
  delete({ commit }, id) {
    return giftRuleApi.delete(id)
      .then(() => commit('GIFT_RULE_REMOVED'))
      .catch(error => {
        commit('GIFT_RULE_REMOVE_FAILED', error.response.data.errors)
        throw error
      })
  },
}

const mutations = {
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  GIFT_RULE_REMOVED() {
    store.dispatch('giftRule/fetchList')
    store.dispatch('message/success', 'PROMOTION.success')
  },
  GIFT_RULE_REMOVE_FAILED(state, errors) {
    store.dispatch('message/error', 'PROMOTION.removeFailure')
    state.errors = errors
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
  form,
}

const watchers = [
  [
    state => state.giftRule.filters,
    _.debounce(async () => await store.dispatch('giftRule/fetchList'), 250),
    { immediate: false, deep: true },
  ],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
